<script setup lang="ts">

import { faTriangleExclamation } from '@fortawesome/pro-regular-svg-icons'

import { AppText } from '@shared/ui/typography'
import { ModalDefault } from '@shared/ui/modals'
import { AppIcon } from '@shared/ui/icons'
import { BtnPrimary, BtnSecondary } from '@shared/ui/buttons'
import { AppBadge } from '@shared/ui/badges'

import LessonTutorSelect from '../LessonTutorSelect.vue'
import LessonTutorFilterFields from '../LessonTutorFilterFields.vue'
import { useLessonCreateTutorModal } from '../../../model/lessons/lesson-create-tutor-modal.hook'

defineOptions({
  name: 'ModalLessonCreateTutor',
})

const {
  refFilters,
  refTutorId,
  refTutorOptions,
  refIsTutorsLoading,
  refDate,
  refSelectedLabel,
  refIsOffSchedule,
  refIsSaveDisabled,
  refIsSaving,
  applyFilters,
  clearFilters,
  save,
  close,
} = useLessonCreateTutorModal()
</script>

<template>
  <ModalDefault
    show
    class-name="modal-lesson-dialog"
    title="Select tutor"
    :loading="refIsTutorsLoading || refIsSaving"
    @click:overlay="close"
  >
    <div class="modal-lesson-create-tutor">
      <LessonTutorFilterFields
        :initial="refFilters"
        :disabled="refIsSaving || refIsTutorsLoading"
        @apply="applyFilters"
        @clear="clearFilters"
      />
      <div class="modal-lesson-create-tutor__pick">
        <LessonTutorSelect
          v-model="refTutorId"
          :options="refTutorOptions"
          :date="refDate"
          :loading="refIsTutorsLoading"
          :disabled="refIsSaving"
        />
        <AppBadge
          v-if="refSelectedLabel"
          class="modal-lesson-create-tutor__availability"
          :color="refSelectedLabel.color"
          :text="refSelectedLabel.text"
        />
      </div>
      <div
        v-if="refIsOffSchedule"
        class="modal-lesson-create-tutor__warning"
        role="status"
      >
        <AppIcon
          :icon="faTriangleExclamation"
          color="amber-500"
        />
        <div class="modal-lesson-create-tutor__warning-content">
          <AppText
            name="body2-medium"
            color="slate-900"
          >
            This time slot is outside the tutor's work schedule.
          </AppText>
          <AppText
            name="body2"
            color="slate-600"
          >
            The lesson will be added anyway.
          </AppText>
        </div>
      </div>
    </div>
    <template #controls>
      <div class="modal-lesson-form__controls">
        <BtnPrimary
          text="Add lesson"
          color="emerald"
          :disabled="refIsSaveDisabled"
          @click="save"
        />
        <BtnSecondary
          text="Cancel"
          color="black"
          :disabled="refIsSaving"
          @click="close"
        />
      </div>
    </template>
  </ModalDefault>
</template>

<style scoped lang="scss" src="./ModalLessonForm.scss" />
